/**
 * Method to call privacy
 * @param {*} form 
 * @param {*} ProfileService
 */
let callPrivacy = (form, ProfileService)=>{
    let privacyVal = 2
    if (form.firstUpLine) {
        privacyVal = form.privacyType
    }
    ProfileService.updatePrivacySettings(privacyVal).then(function (response) {
        form.setPrivacy(response.data.status)
        form.closeDialog()
    }).catch(function (error) {})
}

let callNonJapanPrivacy = (form,ProfileService,profileUtils)=>{
    let prefObj = {
        preferences: {
            visibleInSponsorSearch: form.sponsorSearch
        }
    }
    ProfileService.updateAccountInfo(prefObj)
        .then((response) => {
            if (response && response.data && response.data.account) {
                form.setAccount(response.data.account)
                form.closeDialog()
                profileUtils.publishAnalytics(
                    form.$analytics.category.privacy,
                    'privacy_preferences_update',
                    prefObj
                )
            }
        })
        .catch((error) => {
            form.dialogError = error
        })
}

export default {
    callPrivacy:callPrivacy,
    callNonJapanPrivacy:callNonJapanPrivacy
};
